import { AuthLayout } from '@/shared/ui/Layout/AuthLayout/AuthLayout'

export const layoutLogin = <AuthLayout />
